// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3FZcN","header":"PatientBlock_header__3Yg3L","label":"PatientBlock_label__1pHb3","option":"PatientBlock_option__3_xs1"};